import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import FindCandidate from "@/pages/FindCandidate";
import DeclareEntry from "@/pages/DeclareEntry";
import Directory from "@/pages/Directory";
import CandidateProfile from "@/pages/CandidateProfile";
import Declare from "@/pages/Declare";
import BringToCampaign from "@/pages/BringToCampaign";
import InviteCandidate from "@/pages/InviteCandidate";
import KawarthaLakes2026 from "@/pages/KawarthaLakes2026";
import Privacy from "@/pages/Privacy";
import Legal from "@/pages/Legal";
import Contact from "@/pages/Contact";
import Verify from "@/pages/Verify";
import MyDeclaration from "@/pages/MyDeclaration";
import WitnessPage from "@/pages/WitnessPage";
import VerifyEmail from "@/pages/VerifyEmail";
import WitnessNetwork from "@/pages/WitnessNetwork";
import WitnessVolunteer from "@/pages/WitnessVolunteer";
import ReceiptCard from "@/pages/ReceiptCard";
import Polls from "@/pages/Polls";
import CommunityVoice from "@/pages/CommunityVoice";
import ElectionCentre from "@/pages/ElectionCentre";
import FindMyWard from "@/pages/FindMyWard";
import ElectionsMap from "@/pages/ElectionsMap";
import CandidateFilings from "@/pages/CandidateFilings";
import OntarioDirectory from "@/pages/OntarioDirectory";
import OntarioMunicipality from "@/pages/OntarioMunicipality";
import News from "@/pages/News";
import NewsPost from "@/pages/NewsPost";
import Pita from "@/pages/Pita";
import PitaRequest from "@/pages/PitaRequest";
import Accountability from "@/pages/Accountability";
import AccountabilityInvestigate from "@/pages/AccountabilityInvestigate";
import About from "@/pages/About";
import Alerts from "@/pages/Alerts";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminApplications from "@/pages/admin/Applications";
import AdminCandidates from "@/pages/admin/Candidates";
import AdminDeclarations from "@/pages/admin/Declarations";
import AdminElections from "@/pages/admin/Elections";
import AdminEmails from "@/pages/admin/Emails";
import AdminAuditLog from "@/pages/admin/AuditLog";
import AdminSettings from "@/pages/admin/Settings";
import AdminWebsite from "@/pages/admin/Website";
import AdminNews from "@/pages/admin/News";
import AdminInbox from "@/pages/admin/Inbox";
import AdminCandidateData from "@/pages/admin/CandidateData";
import AdminCoverage from "@/pages/admin/Coverage";
import AdminAlerts from "@/pages/admin/Alerts";
import AdminWitness from "@/pages/admin/Witness";
import AdminIdentity from "@/pages/admin/Identity";
import AdminWitnessNetwork from "@/pages/admin/WitnessNetworkAdmin";
import AdminEmailLog from "@/pages/admin/EmailLog";
import AdminPolls from "@/pages/admin/Polls";
import AdminIntelligence from "@/pages/admin/Intelligence";
import SpotCheck from "@/pages/admin/SpotCheck";
import CoveragePublic from "@/pages/CoveragePublic";
import OntarioIssueMap from "@/pages/OntarioIssueMap";
import WeeklyPulse from "@/pages/WeeklyPulse";
import AskTheCandidates from "@/pages/AskTheCandidates";
import CandidatePortal from "@/pages/CandidatePortal";
import AdminQA from "@/pages/admin/QAAdmin";
import AdminCorrections from "@/pages/admin/Corrections";
import AdminEmailMode from "@/pages/admin/EmailMode";
import AdminRehearsal from "@/pages/admin/Rehearsal";
import AdminLaunchGate from "@/pages/admin/LaunchGate";
import AdminBeta from "@/pages/admin/Beta";
import BetaInfo from "@/pages/BetaInfo";
import Unsubscribe from "@/pages/Unsubscribe";
import CorrectionStatus from "@/pages/CorrectionStatus";
import CompareCandidates from "@/pages/CompareCandidates";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/find-a-candidate" element={<FindCandidate />} />
          <Route path="/declare" element={<DeclareEntry />} />
          <Route path="/candidates" element={<Directory />} />
          <Route path="/ontario" element={<OntarioDirectory />} />
          <Route path="/ontario/:slug" element={<OntarioMunicipality />} />
          <Route path="/ontario/:muniSlug/:year/:officeSlug/:candSlug" element={<CandidateProfile />} />
          <Route path="/ontario/:muniSlug/:year/:officeSlug/:candSlug/declare" element={<Declare />} />
          <Route path="/bring-it-to-my-campaign" element={<BringToCampaign />} />
          <Route path="/candidate-application" element={<BringToCampaign />} />
          <Route path="/invite-a-candidate" element={<InviteCandidate />} />
          <Route path="/kawartha-lakes-2026" element={<KawarthaLakes2026 />} />
          <Route path="/elections" element={<ElectionCentre />} />
          <Route path="/elections/find-my-ward" element={<FindMyWard />} />
          <Route path="/elections/map" element={<ElectionsMap />} />
          <Route path="/candidate-filings" element={<CandidateFilings />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsPost />} />
          <Route path="/pita" element={<Pita />} />
          <Route path="/pita/request" element={<PitaRequest />} />
          <Route path="/accountability" element={<Accountability />} />
          <Route path="/accountability/investigate" element={<AccountabilityInvestigate />} />
          <Route path="/about" element={<About />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/verify/:declarationNumber" element={<Verify />} />
          <Route path="/my-declaration/:ownerToken" element={<MyDeclaration />} />
          <Route path="/receipt-card/:ownerToken" element={<ReceiptCard />} />
          <Route path="/verify-email/:token" element={<VerifyEmail />} />
          <Route path="/witness-network" element={<WitnessNetwork />} />
          <Route path="/polls" element={<Polls />} />
          <Route path="/community-voice" element={<CommunityVoice />} />
          <Route path="/community-voice/weekly" element={<WeeklyPulse />} />
          <Route path="/ask-the-candidates" element={<AskTheCandidates />} />
          <Route path="/candidates/compare" element={<CompareCandidates />} />
          <Route path="/corrections/status" element={<CorrectionStatus />} />
          <Route path="/corrections/status/:reference" element={<CorrectionStatus />} />
          <Route path="/candidate-portal/:token" element={<CandidatePortal />} />
          <Route path="/issue-map" element={<OntarioIssueMap />} />
          <Route path="/coverage" element={<CoveragePublic />} />
          <Route path="/witness-volunteer/:volunteerToken" element={<WitnessVolunteer />} />
          <Route path="/witness" element={<WitnessPage />} />
          <Route path="/witness/:token" element={<WitnessPage />} />
          <Route path="/beta" element={<BetaInfo />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Route>
        <Route path="/admin" element={<AdminLogin />} />
        <Route element={<AdminLayout />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/applications" element={<AdminApplications />} />
          <Route path="/admin/candidates" element={<AdminCandidates />} />
          <Route path="/admin/declarations" element={<AdminDeclarations />} />
          <Route path="/admin/elections" element={<AdminElections />} />
          <Route path="/admin/website" element={<AdminWebsite />} />
          <Route path="/admin/news" element={<AdminNews />} />
          <Route path="/admin/inbox" element={<AdminInbox />} />
          <Route path="/admin/candidate-data" element={<AdminCandidateData />} />
          <Route path="/admin/coverage" element={<AdminCoverage />} />
          <Route path="/admin/alerts" element={<AdminAlerts />} />
          <Route path="/admin/witness" element={<AdminWitness />} />
          <Route path="/admin/witness-network" element={<AdminWitnessNetwork />} />
          <Route path="/admin/identity" element={<AdminIdentity />} />
          <Route path="/admin/email-log" element={<AdminEmailLog />} />
          <Route path="/admin/polls" element={<AdminPolls />} />
          <Route path="/admin/qa" element={<AdminQA />} />
          <Route path="/admin/corrections" element={<AdminCorrections />} />
          <Route path="/admin/email-mode" element={<AdminEmailMode />} />
          <Route path="/admin/rehearsal" element={<AdminRehearsal />} />
          <Route path="/admin/launch-gate" element={<AdminLaunchGate />} />
          <Route path="/admin/beta" element={<AdminBeta />} />
          <Route path="/admin/intelligence" element={<AdminIntelligence />} />
          <Route path="/admin/coverage/spot-check" element={<SpotCheck />} />
          <Route path="/admin/emails" element={<AdminEmails />} />
          <Route path="/admin/audit-log" element={<AdminAuditLog />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
        </Route>
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
